import { type PlanFeatureType } from '@/shared/plan';

export const BUILD_PRO_FEATURE_COACHMARK_FEATURES = [
  'AI_TUTOR',
  'AI_QUIZSET_TRANSLATION',
  'CONTINUE_NEXT_QUIZSET',
  'PRIVATE_QUIZ',
] as const satisfies readonly PlanFeatureType[];

export type BuildProFeatureCoachmarkFeature =
  (typeof BUILD_PRO_FEATURE_COACHMARK_FEATURES)[number];
